import classNames from 'classnames';
import React from 'react';

const IconButton = ({
  id,
  leftIconClassName,
  leftIcon,
  rightIconClassName,
  rightIcon,
  type,
  children,
  onClick,
  disabled,
  className,
  style,
  size,
  variant,
  ...props
}) => {
  return (
    <React.Fragment>
      <button
        id={id}
        className={classNames(
          {
            [`btn-mx-${variant}`]: !!variant,
          },
          className
        )}
        type={type}
        disabled={disabled}
        style={style}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    </React.Fragment>
  );
};

IconButton.defaultProps = {
  type: 'button',
  disabled: false,
  size: 'default',
  variant: 'primary',
};

export default IconButton;
